export const getPurchaseOrderData = (t) => {
  const purchaseOrderColumns = [
    {
      Header: "ID",
      accessor: "formattedId",
      sortable: true,
      canRenderFilter: true,
    },
    {
      Header: "Date",
      accessor: "orderDate",
      sortable: true,
    },
    {
      Header: "Status",
      accessor: "status",
      sortable: true,
    },
    {
      Header: "Subtotal",
      accessor: "subtotal",
      sortable: false,
      Cell: ({ row }) => <>€{row.original.subtotal.toFixed(2)}</>,
    },
    {
      Header: "Tax",
      accessor: "tax",
      sortable: false,
      Cell: ({ row }) => <>€{row.original.tax.toFixed(2)}</>,
    },
    {
      Header: "Total",
      accessor: "total",
      sortable: false,
      Cell: ({ row }) => <>€{row.original.total.toFixed(2)}</>,
    },
  ];

  return { purchaseOrderColumns };
};

export default getPurchaseOrderData;
